export type EventCurrent = {
  channel: string;
  id: string;
  startTime: string;
};

export class EventFetcher {
  eventID: string | undefined;
  url: string | undefined;
  channelID: string | undefined;

  constructor(config: { url: string; channelID: string }) {
    this.url = config.url;
    this.channelID = config.channelID;
  }

  public async fetchEvent(
    option: "current" | "next",
  ): Promise<EventCurrent | null> {
    if (!this.url) throw new Error("URL not set for FetchCurrentEvent.");
    const response = await fetch(
      option==="current" ? `https://${this.url}/event/current/${this.channelID}/0 ` : `https://${this.url}/event/next/${this.channelID}/1`,
    );
    if (response.ok) {
      const data = (await response.json()) as Record<string, EventCurrent>;
      const eventArr = Object.values(data);
      console.log("EVENTS FETCHED: ", eventArr);

      const event = eventArr[0];
      return event;
    }

    return null;
  }
}
